import { toast } from 'react-toastify';
import { useNavigateReplace } from 'hooks';
import { useDeleteBlankMutation, useLazyGetDownloadBlankQuery, useLazyGetDownloadPatientCardQuery } from 'store/api';
import { routes } from 'routes';

export function useBlankActions(refetch: () => void) {
	const navigate = useNavigateReplace();

	// Мутации/запросы
	const [deleteBlank, { isLoading: isDeleting }] = useDeleteBlankMutation();
	const [downloadBlank] = useLazyGetDownloadBlankQuery();
	const [downloadPatientCard] = useLazyGetDownloadPatientCardQuery();

	// Если нужно модальное окно для подтверждения

	// 1. Удалить бланк
	const handleDeleteBlank = async (id: number) => {
		if (id == null) {
			console.error('Некорректный идентификатор бланка:', id);
			return;
		}
		try {
			await deleteBlank(id).unwrap();
			refetch(); // обновляем список
			toast.success('Бланк успешно удалён');
		} catch (error) {
			console.error('Ошибка при удалении бланка:', error);
			toast.error('Ошибка при удалении бланка');
		}
	};

	// 2. Скачать бланк
	const handleDownloadBlank = async (id: number | number[]) => {
		if (id == null) {
			console.error('Некорректный идентификатор бланка:', id);
			return;
		}
		try {
			let blob: Blob;
			let filename: string;

			if (Array.isArray(id)) {
				if (id.length === 1) {
					// Один бланк - скачиваем как PDF
					blob = await downloadPatientCard(id[0]).unwrap();
					filename = `${id[0]}.pdf`;
				} else {
					// Несколько бланков - скачиваем как архив
					blob = await downloadBlank(id).unwrap();
					filename = 'blanks.zip';
				}
			} else {
				// Один бланк - скачиваем как PDF
				blob = await downloadPatientCard(id).unwrap();
				filename = `${id}.pdf`;
			}

			const url = URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			link.remove();
		} catch (error) {
			console.error('Ошибка при скачивании бланка:', error);
			toast.error('Не удалось скачать бланк');
		}
	};

	// 3. Редактировать бланк
	const handleEditBlank = (id: number) => {
		if (!id) return;
		navigate(
			routes.blank_id.getPath({
				clientId: id,
			}),
		);
	};

	// 4. Добавить оценку (ADD_RATING)
	const handleAddRating = (id: number) => {
		if (!id) return;
		navigate(
			routes.client_blank.getPath({
				clientId: id,
			}),
		);
	};

	return {
		isDeleting, // нужно, если хотим отображать "Удаление..." на кнопке
		handleDeleteBlank,
		handleDownloadBlank,
		handleEditBlank,
		handleAddRating,
	};
}
